<main class="profile-shell">
    <!-- Admin-configured instruction banner (BiddingUtils) — right-aligned on
         desktop, full-width on small screens via its own component styles. -->
    <div class="profile-shell__instruction" *ngIf="instruction">
        <vb-bidding-instruction-display [instruction]="instruction" />
    </div>

    <div class="profile-shell__panel">
        <vb-sidebar
            variant="wide"
            [showBrand]="false"
            [groups]="groups"
            [activeId]="activeId"
            (tabSelect)="onTab($event)"></vb-sidebar>

        <div class="profile-shell__content">
            <router-outlet></router-outlet>
        </div>
    </div>
</main>
